const mainCollection = () => {
    const selectors = {
        collectionSection: '[data-section-type="collection"]',
        collectionSort: 'data-cardigang-collection-sort',
        collectionProductsContainer: '.collection__products',
        collectionProducts: '.product-item',
        collectionLoading: '.collection__loading',
    };
    const collectionSections = document.querySelectorAll(selectors.collectionSection);
    collectionSections.forEach((section) => {
        const loadingIcon = section.querySelector(selectors.collectionLoading);
        const checkSort = () => {
            const productsContainer = section.querySelector(selectors.collectionProductsContainer);
            const collectionSort = productsContainer.getAttribute(selectors.collectionSort);
            const products = productsContainer.querySelectorAll(selectors.collectionProducts);
            const comparator = (a, b) => {
                if (a.dataset.cardigangSortingPrice < b.dataset.cardigangSortingPrice)
                    return -1;
                if (a.dataset.cardigangSortingPrice > b.dataset.cardigangSortingPrice)
                    return 1;
                return 0;
            };
            const sortData = (order) => {
                const subjectsArray = Array.from(products);
                const sorted = subjectsArray.sort(comparator);
                if (order == 'price-ascending') {
                    sorted.forEach((e) => productsContainer.appendChild(e));
                }
                if (order == 'price-descending') {
                    const reversed = sorted.reverse();
                    reversed.forEach((e) => productsContainer.appendChild(e));
                }
            };
            if (collectionSort == 'price-ascending') {
                sortData('price-ascending');
            }
            if (collectionSort == 'price-descending') {
                sortData('price-descending');
            }
        };
        const mutationConfig = { attributes: true, childList: false, subtree: false };
        const mutationCallback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                checkSort();
            }
        };
        const observer = new MutationObserver(mutationCallback);
        observer.observe(loadingIcon, mutationConfig);
        checkSort();
    });
};
export { mainCollection };
